import { Link } from "easy-page-router/react";
import { Loading, Separator } from ".";
import { useSSRHook } from "../../ssrh/client";

import { Project } from "../../types";
import Icon from "@mdi/react";
import { mdiArrowRightThin } from "@mdi/js";

export default function LastProjects() {
    const [projects, error, isLoading, reload] = useSSRHook<Project[]>("/api/projects?limit=6");


    return <div className="last-projects">
        <div className="background">
            {isLoading && <Loading />}
            <div className="title">
                <h2>Poslední Projekty</h2>
                <Separator />
            </div>
            <div className="links">
                {projects && projects.map(p => <Link key={p._id} to={`/projekt/${encodeURIComponent(p.url)}`}>
                    {p.title} <Icon path={mdiArrowRightThin} size={1} />
                </Link>)}
            </div>
        </div>
    </div>
}